enum ActionType {
  SET_IS_USER_ROOT_CONTRIBUTER = 'AUTH/SET_IS_USER_ROOT_CONTRIBUTER',
  SET_TEANANTS = 'AUTH/TENANTS',
  SET_CONFIG = 'AUTH/CONFIG',
  SET_AUTH_ERROR = 'AUTH/ERROR',
  SET_USER = 'SET_USER',
  SAVE_MAP_STATE = 'SAVE_MAP_STATE',
  SET_MAP = 'SET_MAP',
  SET_LAYERS = 'SET_LAYERS',
  FETCH_PROJECTS = 'FETCH_PROJECTS',
  PROJECTS_FETCHED = 'PROJECTS_FETCHED',
  FETCH_PROJECTS_FAILED = 'FETCH_PROJECTS_FAILED',
  SET_CURRENT_PROJECT_AND_PATH = 'SET_CURRENT_PROJECT_PATH',
  GET_PROJECTANDPARENT = 'PROJECT/GET_PROJECTANDPARENT',
  SET_PROJECTANDPARENT = 'PROJECT/SET_PROJECTANDPARENT',
  LOADING_PROJECTANDPARENT = 'PROJECT/LOADING',
  GET_PROJECTCONTENT = 'PROJECTCONTENT/GET',
  SET_PROJECTCONTENT = 'PROJECTCONTENT/SETPROJECTCONTENT',
  LOADING_PROJECTCONTENT = 'PROJECTCONTENT/LOADING',
  OPEN_PROJECTCONTENT_DIALOG = 'PROJECTCONTENT/DIALOG_OPEN',
  SET_PROJECTCONTENT_PAGE = 'PROJECTCONTENT/SET_PAGE',
  SET_PROJECTCONTENT_ROWSPERPAGE = 'PROJECTCONTENT/SET_ROWSPERPAGE',
  SET_PROJECTCONTENT_ORDER = 'PROJECTCONTENT/SET_ORDER',
  SET_PROJECTCONTENT_ORDERBY = 'PROJECTCONTENT/SET_ORDERBY',
  SET_MESH_NAME = 'SET_MESH_NAME',
  SET_MESH_FEATURES = 'SET_MESH_FEATURES',
  SET_MESH_MODEL_TYPE = 'SET_MESH_MODEL_TYPE',
  SET_MESH_PROJECTION = 'SET_MESH_PROJECTION',
  SET_MESH_PROJECTION_WKT = 'SET_MESH_PROJECTION_WKT',
  SET_MESH_PROJECTION_SHORTNAME = 'SET_MESH_PROJECTION_SHORTNAME',
  SET_MESH_TILEGRID_CONFIG = 'SET_MESH_TILEGRID_CONFIG',
  SET_MESH_TILEGRID_PROCESS = 'SET_MESH_TILEGRID_PROCESS',
  SET_EXTRACTION_PERIOD = 'SET_EXTRACTION_PERIOD',
  SET_EXTRACTION_STARTDATE = 'SET_EXTRACTION_STARTDATE',
  SET_EXTRACTION_ENDDATE = 'SET_EXTRACTION_ENDDATE',
  SET_EXTRACTION_INITIALDATE = 'SET_EXTRACTION_INITIALDATE',
  SET_EXTRACTION_INITIAL_PERIOD = 'SET_EXTRACTION_INITIAL_PERIOD',
  SET_SAVE_FORCINGS_IN_NATIVE_GRID_RESOLUTION = 'SET_SAVE_FORCINGS_IN_NATIVE_GRID_RESOLUTION',
  SET_EXTRAPOLATE_SPATIAL_GAPS = 'SET_EXTRAPOLATE_SPATIAL_GAPS',
  SET_EXTTRACTION_SEA_LEVEL_ADJUSTMENT = 'SET_EXTTRACTION_SEA_LEVEL_ADJUSTMENT',
  SET_SHOW_MESSAGE = 'SET_SHOW_MASSAGE',
  SET_MESSAGE = 'SET_MESSAGE',
  SET_MESSAGE_TYPE = 'SET_MESSAGE_TYPE',
  SET_DATA_EXTRACTION_BUILDER = 'SET_DATA_EXTRACTION_BUILDER',
  SET_MESH_FILES_PLATFORM = 'SET_MESH_FILES_PLATFORM',
  SET_MESH_FILES_IMPORTED = 'SET_MESH_FILES_IMPORTED',
  RM_PROGRESS_ITEM = 'RM_PROGRESS_ITEM',
  ADD_PROGRESS_ITEM = 'ADD_PROGRESS_ITEM',
  UPDATE_PROGRESS_ITEM = 'UPDATE_PROGRESS_ITEM',
  ADDUP_PROGRESS_ITEM = 'ADDUP_PROGRESS_ITEM',
  RM_POLLING_ITEM = 'RM_POLLING_ITEM',
  ADD_POLLING_ITEM = 'ADD_POLLING_ITEM',
  UPDATE_POLLING_ITEM = 'UPDATE_POLLING_ITEM',
  ADDUP_POLLING_ITEM = 'ADDUP_POLLING_ITEM',
  SET_POLLING = 'SET_POLLING',
  SET_POLLING_UPDATE = 'SET_POLLING_UPDATE',
  SET_POLLING_REMOVELS = 'SET_POLLING_REMOVELS',
  ADD_NOTIFICATION = 'ADD_NOTIFICATION',
  HIDE_NOTIFICATION_DOT = 'HIDE_NOTIFICATION_DOT',
  DATA_EXTRACTION_BUILDER_START = 'DATA_EXTRACTION_BUILDER_START',
  UPDATE_DATA_EXTRACTION_BUILDER = 'UPDATE_DATA_EXTRACTION_BUILDER',
}

export default ActionType